<div class="content-filters">
  <div class="row">
    <div class="col-sm-6 d-flex">
      <div class="col-md-4 ps-3 pe-3">
        <!--<nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                    [(model)]="TemplateSearchOption"
                    [source]="searchOptions"
                    value="id"
                    display="description">
        </nbc-select>-->
        <nbc-dropdown [(model)]="TemplateSearchOption"
                      [source]="searchOptions"
                      display="description" value="id"></nbc-dropdown>
      </div>
      <div class="col-md-4 ps-3 pe-3">
        <input class="form-control filter-textbox event-search"
               maxlength="100"
               type="text"
               name="TemplateSearchValue"
               placeholder="Enter Value"
               [(ngModel)]="TemplateSearchValue" style="height:34px;" />
      </div>
      <div class="col-md-4 ps-3 pe-3">
        <button type="submit" class="btn btn-secondary" (click)="searchTemplates()">Search</button>&nbsp;
        <button type="button" class="btn btn-default" (click)="clearSearch()">Clear</button>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group form-inline float-end">
        <nbc-dropdown [(model)]="filter.isActive"
             [source]="filter.templateTypes"
             (nbcOnOptionSelect)="changeActive()"
              display="name" value="value"></nbc-dropdown>
      </div>
    </div>
  </div>
  <div class="row view-options">
    <div class="col-md-7" style="text-align:left">
      <div class="form-inline form-sort-options">
        <div class="form-group">
          <nbc-page-size [source]='pageSize'
                         [model]="queryContainer.query.pageSize"
                         (nbcValueChange)="searchPage($event)">
          </nbc-page-size>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="form-group pagination-container d-flex pull-right">
        <label class="pagination-results">
          <pagination-label pageSize="{{queryContainer.query.pageSize}}"
                            currentPage="{{queryContainer.query.currentPage}}"
                            totalRecords="{{queryContainer.query.totalRecords}}"></pagination-label>
        </label>
        <nbc-pagination totalItems="{{queryContainer.query.totalRecords}}"
                        itemsPerPage="{{queryContainer.query.pageSize}}"
                        [currentPage]="queryContainer.query.currentPage"
                        (pageChanged)="eventSearch($event)"></nbc-pagination>
      </div>
    </div>
  </div>
</div>
